var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkillsInitialsCol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 24,
    fill: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12985_10675)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 768,
    transform: "translate(-412 -655)",
    fill: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -356,
    y: -8,
    width: 912,
    height: 80,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -355.5,
    y: -7.5,
    width: 911,
    height: 79,
    rx: 7.5,
    stroke: "#071B22",
    strokeOpacity: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 24,
    rx: 12,
    fill: "#82E1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.27142 12.0001C11.0545 12.0001 12.5 10.5546 12.5 8.77154C12.5 10.5542 13.9448 11.9994 15.7273 12.0001C13.9448 12.0008 12.5 13.446 12.5 15.2287C12.5 13.4456 11.0545 12.0001 9.27142 12.0001C7.48833 12.0001 6.04285 13.4456 6.04285 15.2287L6.04285 18.4573L9.27143 18.4573C11.0545 18.4573 12.5 17.0118 12.5 15.2287C12.5 17.0118 13.9455 18.4573 15.7286 18.4573L18.9572 18.4573L18.9572 15.2287C18.9572 13.446 17.5124 12.0008 15.7298 12.0001C17.5124 11.9994 18.9572 10.5542 18.9572 8.77154L18.9572 5.54296L15.7286 5.54296C13.9455 5.54296 12.5 6.98845 12.5 8.77154C12.5 6.98845 11.0545 5.54296 9.27142 5.54296L6.04285 5.54296L6.04285 8.77154C6.04285 10.5546 7.48833 12.0001 9.27142 12.0001Z",
    fill: "#009996"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2524 10.1108H27.9229C27.8717 9.8267 27.7766 9.5767 27.6374 9.3608C27.4982 9.14489 27.3277 8.96165 27.126 8.81108C26.9243 8.66051 26.6985 8.54687 26.4485 8.47017C26.2013 8.39347 25.9385 8.35511 25.6601 8.35511C25.1573 8.35511 24.707 8.48153 24.3092 8.73438C23.9144 8.98722 23.6019 9.35795 23.3717 9.84659C23.1445 10.3352 23.0308 10.9318 23.0308 11.6364C23.0308 12.3466 23.1445 12.946 23.3717 13.4347C23.6019 13.9233 23.9158 14.2926 24.3135 14.5426C24.7112 14.7926 25.1587 14.9176 25.6558 14.9176C25.9314 14.9176 26.1928 14.8807 26.4399 14.8068C26.6899 14.7301 26.9158 14.6179 27.1175 14.4702C27.3192 14.3224 27.4896 14.142 27.6289 13.929C27.7709 13.7131 27.8689 13.4659 27.9229 13.1875L29.2524 13.1918C29.1814 13.6207 29.0436 14.0156 28.8391 14.3764C28.6374 14.7344 28.3774 15.044 28.0592 15.3054C27.7439 15.5639 27.3831 15.7642 26.9769 15.9062C26.5706 16.0483 26.1274 16.1193 25.6473 16.1193C24.8916 16.1193 24.2183 15.9403 23.6274 15.5824C23.0365 15.2216 22.5706 14.706 22.2297 14.0355C21.8916 13.3651 21.7226 12.5653 21.7226 11.6364C21.7226 10.7045 21.8931 9.90483 22.234 9.23722C22.5749 8.56676 23.0408 8.05256 23.6317 7.6946C24.2226 7.33381 24.8945 7.15341 25.6473 7.15341C26.1104 7.15341 26.5422 7.22017 26.9428 7.35369C27.3462 7.48437 27.7084 7.67756 28.0294 7.93324C28.3504 8.18608 28.6161 8.49574 28.8263 8.86222C29.0365 9.22585 29.1786 9.64205 29.2524 10.1108Z",
    fill: "#071B22"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12985_10675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 768,
    fill: "white",
    transform: "translate(-412 -655)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsInitialsCol);
export default __webpack_public_path__ + "static/media/Skills Initials Col.5b926b9dc5ee5a4f8bc9460a34d9c65e.svg";
export { ForwardRef as ReactComponent };